import { applyTokens } from "../../../utilities/applyTokens.js";
const loadingIndicator = (tokens) => {
    const { loadingIndicator } = tokens.component;
    const { circular, linear } = loadingIndicator;
    return {
        MuiCircularProgress: {
            styleOverrides: {
                circle: Object.assign(Object.assign({}, applyTokens(circular.indicator)), { strokeLinecap: "round" }),
                svg: {
                    position: "relative",
                },
                root: {
                    position: "relative",
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(linear.track)), { 
                    // hack to cover the bar around the rounded corners
                    "&::after": {
                        content: "''",
                        display: "block",
                        position: "absolute",
                        inset: 0,
                        borderRadius: "inherit",
                        boxShadow: `inset 0px 0px 0px calc(${linear.track.paddingLeft.value} - ${linear.track.borderWidth.value}) ${linear.track.backgroundColor.value}`,
                    } }),
                bar: Object.assign(Object.assign({}, applyTokens(linear.indicator)), { top: "50%", transform: "translateY(-50%)" }),
                bar1Determinate: {
                    top: "3px",
                },
            },
        },
    };
};
export default loadingIndicator;
export const emptyCircularProgressPresets = {
    size: {
        xs: {},
        sm: {},
        md: {},
        lg: {},
        xl: {},
        "2xl": {},
    },
};
export const CircularProgressPresets = (tokens) => {
    const { loadingIndicator: { circular }, } = tokens.component;
    const generateStyles = (size) => ({
        size: circular[size].width.value,
        sx: {
            "& svg circle": {
                strokeWidth: circular[size].indicator.strokeWidth.value,
            },
            "&.MuiCircularProgress-root": {
                // hack to add a track behind the indicator
                // we're using an SVG circle to match the shape of the indicator
                "&::before": Object.assign({ content: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='22 22 44 44'%3E%3Ccircle cx='44' cy='44' r='20.2' fill='none' stroke-width='${circular[size].track.strokeWidth.value}' stroke='${circular.track.color.value.replace("#", "%23")}'%3E%3C/circle%3E%3C/svg%3E")`, display: "block", position: "absolute", inset: 0 }, (size === "xs" ? { top: "-2.5px" } : {})),
            },
        },
    });
    return {
        size: {
            xs: generateStyles("xs"),
            sm: generateStyles("sm"),
            md: generateStyles("md"),
            lg: generateStyles("lg"),
            xl: generateStyles("xl"),
            "2xl": generateStyles("2xl"),
        },
    };
};
//# sourceMappingURL=loadingIndicator.js.map